const DefaultAvatarIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 3.25C8.37665 3.25 6.25 5.37665 6.25 8C6.25 10.6234 8.37665 12.75 11 12.75C13.6234 12.75 15.75 10.6234 15.75 8C15.75 5.37665 13.6234 3.25 11 3.25ZM7.75 8C7.75 6.20507 9.20507 4.75 11 4.75C12.7949 4.75 14.25 6.20507 14.25 8C14.25 9.79493 12.7949 11.25 11 11.25C9.20507 11.25 7.75 9.79493 7.75 8Z"
        fill="#030C23"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 14.0485 1.51989 16.8016 3.55751 18.7571C5.48833 20.61 8.11182 21.75 11 21.75C13.8882 21.75 16.5117 20.61 18.4425 18.7571C20.4801 16.8016 21.75 14.0485 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75C16.1086 1.75 20.25 5.89137 20.25 11C20.25 13.1948 19.4863 15.2103 18.2089 16.7966C17.4149 15.2828 15.8286 14.25 14 14.25H8C6.17143 14.25 4.58513 15.2828 3.79109 16.7966C2.51372 15.2103 1.75 13.1948 1.75 11ZM14 15.75C15.4339 15.75 16.6521 16.6792 17.0831 17.9685C15.4565 19.3898 13.3294 20.25 11 20.25C8.67062 20.25 6.54352 19.3898 4.91687 17.9685C5.34791 16.6792 6.56613 15.75 8 15.75H14Z"
        fill="#030C23"
      />
    </svg>
  );
};

export default DefaultAvatarIcon;
